import React from 'react';
import { Redirect, Route, Router } from 'react-router';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";

import App from './components/App';
import Vision from './components/Vision';
import Management from './components/Management';
import Contactus from './components/Contactus';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';

import SignIn from './components/SignIn';

import Admin from './components/Admin';

import Dashboard from './components/Dashboard';

import AdmissionAlerts from './components/AdmissionAlerts';
import StudentAlertDetail from './components/AlertDetail';

import Scholarship from './components/Scholarship';
import ScholarshipDetail from './components/ScholarshipDetail';

import Careers from './components/Careers';
import StudentCareerDetail from './components/CareerDetail';

import Favourites from './components/Favourites';
import StudentProfile from './components/StudentProfile';
import StudentSessionManagerClass from './components/ActivityRouter';


export const fakeAuth = {
  isAuthenticated: false,
  authenticate(cb) {
    this.isAuthenticated = true
    setTimeout(cb, 100)
  },
  signout(cb) {
    this.isAuthenticated = false
    setTimeout(cb, 100)
  }
}


const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    fakeAuth.isAuthenticated === true
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/signIn',
        state: { from: props.location }
      }} />
  )} />
)

const Routes = (props) => (
  <MuiThemeProvider>
    <StudentSessionManagerClass/>
    <Router {...props}>
      <Route path="/" component={App} />
      <Route path="/termAndConditions" component={TermsAndConditions} />
      <Route path='/privacyPolicy' component={PrivacyPolicy} />
      <Route path='/contact' component={Contactus} />
      <Route path="/management" component={Management} />
      <Route path="/vision" component={Vision} />
      <Route path="/signIn" component={SignIn} />
      <Route path="/admin/signIn" component={SignIn} />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/admissionAlerts" component={AdmissionAlerts} />
      <Route path="/scholarship" component={Scholarship} />
      <Route path="/careers" component={Careers} />
      <Route path="/alertDetail" component={StudentAlertDetail} />
      <Route path="/careerDetail" component={StudentCareerDetail} />
      <Route path="/scholarshipDetail" component={ScholarshipDetail} />
      <Route path="/favourites" component={Favourites} />
      <Route path="/profile" component={StudentProfile} />
      <Route path="/signIn/resetpassword" component={SignIn} />

      <PrivateRoute path="/admin" component={Admin} />
    </Router>
    <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={false}
      pauseOnHover
    />
  </MuiThemeProvider>
);

export default Routes;



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/